import { render, staticRenderFns } from "./AddFreeSkills.vue?vue&type=template&id=19bdb978&scoped=true&"
import script from "./AddFreeSkills.vue?vue&type=script&lang=js&"
export * from "./AddFreeSkills.vue?vue&type=script&lang=js&"
import style0 from "./AddFreeSkills.vue?vue&type=style&index=0&id=19bdb978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bdb978",
  null
  
)

export default component.exports